import { API,  API_POST } from "../../Config";

export const handleUpdatePageLinks = (payload) => {
    const f = new FormData();
    f.append("name", payload.name)
    f.append("description", payload.description)
    f.append("photo", payload.file)
    f.append("link", payload.link)
    f.append("photo", payload.file)
    f.append("id", payload.id)
   
  
    return API_POST(API.UpdateHomepageLink, f);
  };